export const config = {
  appId: process.env.REACT_APP_MS_SSO_APP_ID,
  redirectUri: process.env.REACT_APP_MS_SSO_REDIRECT_URI,
  scopes: [
    'user.read',
    'mailboxsettings.read',
    'calendars.readwrite'
  ]
};

const runtimeNavigatorConfig = typeof window !== 'undefined'
  && window.__EBH_RUNTIME_CONFIG__
  && window.__EBH_RUNTIME_CONFIG__.navigatorIntegration;
const allowBuildTimeNavigatorFallback = process.env.NODE_ENV !== 'production';

export const navigatorIntegrationConfig = {
  enabled: runtimeNavigatorConfig
    ? runtimeNavigatorConfig.enabled === true
    : allowBuildTimeNavigatorFallback
      && process.env.REACT_APP_NAVIGATOR_INTEGRATION_ENABLED === 'true',
  origin: runtimeNavigatorConfig
    ? runtimeNavigatorConfig.origin || ''
    : allowBuildTimeNavigatorFallback
      ? process.env.REACT_APP_NAVIGATOR_ORIGIN || ''
      : '',
};
